module.exports = __webpack_public_path__ + "static/media/phonecoverpage4.83bafb17.png";